import React from "react";

const PERSONAS = [
  {
    title: "The Lab Director Who Is Also the Quality Manager",
    body: "You run a 5–50 person CLIA or CAP lab without a dedicated QA department. When CAP sends a deficiency notice, you're the one pulling records.",
  },
  {
    title: "The QC Manager at a Specialty or Contract Testing Lab",
    body: "You serve regulated clients who audit you. You need GxP-aligned documentation without paying $3K–$10K/month for an enterprise QMS.",
  },
  {
    title: "The Solo Compliance Consultant",
    body: "You support 5–15 lab clients and rebuild the same documentation from scratch for each one. LabComplyx is your infrastructure.",
  },
];

export default function WhoItsFor() {
  return (
    <section className="py-16 bg-background">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-brand-navy text-center mb-10">Who it's for</h2>
        <div className="grid md:grid-cols-3 gap-6">
          {PERSONAS.map((p) => (
            <div key={p.title} className="bg-card border border-border border-t-4 border-t-brand-teal rounded-[10px] p-7">
              <h3 className="text-base font-bold text-brand-navy mb-3">{p.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}